import React from 'react';

const SEVERITY_STYLES = {
  high:   { bg: 'rgba(239, 68, 68, 0.10)', color: '#F07070', border: 'rgba(239, 68, 68, 0.20)' },
  medium: { bg: 'rgba(234, 179, 8, 0.10)', color: '#E5C040', border: 'rgba(234, 179, 8, 0.20)' },
  low:    { bg: 'rgba(34, 197, 94, 0.10)', color: '#50D080', border: 'rgba(34, 197, 94, 0.20)' },
};

const DEFAULT = { bg: 'rgba(148, 163, 184, 0.08)', color: '#8890A0', border: 'rgba(148, 163, 184, 0.15)' };

export default function SeverityBadge({ severity }) {
  if (!severity) return null;
  const s = SEVERITY_STYLES[severity] || DEFAULT;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 8px', borderRadius: '6px',
      fontSize: '9px', fontWeight: 700,
      textTransform: 'uppercase', letterSpacing: '0.1em',
      background: s.bg, color: s.color,
      borderLeft: `2px solid ${s.color}`,
    }}>
      {severity}
    </span>
  );
}
